import { Dispatch, useCallback } from 'react';
import {
  LocationChoice,
  renderLocationChoice,
} from '../../../components/SearchHeader/types/LocationChoice';
import { safeMemo } from '../../../util/safeMemo';
import { LocationListItem } from './LocationSearch.styles';

export const LocationSearchItem = safeMemo(
  ({ choice, onChoose, index, selected, onSelect }: Props) => {
    const handleClick = useCallback(() => onChoose?.(choice), [choice, onChoose]);

    const renderSuburbText = () => {
      if (choice.suburb && choice.suburb.name) {
        return `${choice.suburb.name}, ${choice.suburb.state || ''} ${
          choice.suburb.postcode || ''
        }`;
      }

      return renderLocationChoice(choice);
    };

    return (
      <LocationListItem
        data-testid="location-list-item"
        onMouseDown={handleClick}
        onMouseEnter={() => onSelect(index)}
        aria-selected={selected}
      >
        <>{renderSuburbText()}</>
      </LocationListItem>
    );
  },
);

interface Props {
  choice: LocationChoice;
  onChoose?: Dispatch<LocationChoice>;
  index: number;
  selected: boolean;
  onSelect: Dispatch<number>;
}
